module.exports = __webpack_public_path__ + "img/help-step-2.98ca6a71.png";